import { Card } from '@ipfabric/ui-components/Card/Card';
import { Link } from '@ipfabric/ui-components/Link/Link';
import type { FC } from 'react';
import { aimTeaserContent } from './aimTeaserContent';

export const AimTeaserPage: FC = () => (
  <div className='flex flex-1 items-center justify-center'>
    <div className='w-[560px] max-w-full'>
      <h2 className='text-level-4 font-semibold text-default mt-0 mb'>
        {aimTeaserContent.title}
      </h2>
      <Card className='p-xl'>
        {/* mb-xl is one full line height, rendering the blank line the copy calls for */}
        <p className='text-lg text-default mt-0 mb-xl'>
          {aimTeaserContent.infoText}{' '}
          <Link
            renderAs='anchor'
            size='large'
            href={aimTeaserContent.infoUrl}
            elementProps={{
              target: '_blank',
              rel: 'noreferrer',
            }}
            className='text-lg'
          >
            here
          </Link>
          .
        </p>
        <p className='text-lg text-default my-0'>
          {aimTeaserContent.contactText}{' '}
          <Link
            renderAs='anchor'
            size='large'
            href={`mailto:${aimTeaserContent.supportEmail}`}
            className='text-lg'
          >
            {aimTeaserContent.supportEmail}
          </Link>
          .
        </p>
      </Card>
    </div>
  </div>
);
